<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #right-element>
            <button v-if="statusSchoolYear" @click="this.showModal = true" class="btn button btn-primary" :disabled="loading">
              <i class="icon-Add"></i>
              {{ $t("button.addMatiere") }}
            </button>
          </template>

          <template v-slot:left-element>
            <h3>{{ $t("title.courses") }}</h3>
          </template>
        </TopTemplate>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ $t("common.coursesExist") }}</div>

    <div v-if="!loading && courses.length > 0">
      <div class="container-fluid matiere-liste">
        <div class="alert alert-success" role="alert" v-if="is_created">
          {{ $t("common.succesCourse") }}
        </div>
        <div class>
          <h3 v-if="statusSchoolYear">{{ $t("title.cocherCourses") }} </h3>
          <div class="row items-wrapper">
            <div
              v-for="course in courses"
              :key="course.id"
              class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer"
              @click="checkItem(course.id), (course.is_checked = !course.is_checked)"
            >
              <div class="matiere-item" :class="{'matiere-background': course.is_checked}">
                <span>{{ course.name }}</span>
                <label class="container-checkbox">
                  <input v-model="selected" type="checkbox" :value="course.id" />
                  <span class="checkmark" :class="course.is_checked === true ? 'chekedchek' : ''"></span>
                </label>
              </div>
            </div>
          </div>

          <div v-if="statusSchoolYear" class="text-end">
            <a class="btn button btn-primary btn-soumettre" :disabled="loading" @click="onSubmitCreateCourse">
              <i class="icon-Check"></i>
              {{ $t("button.envoi") }}
            </a>
          </div>
        </div>
      </div>
      <!-- modal -->
      <div v-if="showModal" class="modal-vue">
        <div class="overlay" @click="hideModal()"></div>
        <div class="modal-edition modal-rdv">
          <div class="titre-parent">
            <h3 class="title-modal">{{ $t("title.addMatire") }}</h3>
            <button class="close" @click="hideModal()">
              <i class="icon-Add" />
            </button>
          </div>
          <div class="body-parent">
            <form @submit.prevent="addMatiere()" novalidate autocomplete="off">
              <div class="spec-inputs">
                <div class="row">
                  <div class="col-md-12">
                    <div class="simple-input">
                      <div>
                        <label> Nom de la matière </label>
                        <input v-model="nameMatiere" type="text" class="form-control" :class="{'is-invalid': v$.nameMatiere.$error}" />
                        <span v-if="v$.nameMatiere.$error" class="invalid-feedback">{{ v$.nameMatiere.$errors[0].$message }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 buttons bloc-btn">
                    <div class="button-left">
                      <button type="button" class="btn btn-outline-primary button cancel" :disabled="loading" @click="hideModal()">
                        <i class="icon-Add" />
                        {{ $t("button.annuler") }}
                      </button>
                    </div>
                    <div class="button-right d-flex">
                      <button type="submit" class="btn button btn-primary" :disabled="loading || isConfirmed">
                        <i class="icon-Check" />
                        {{ $t("button.save") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {Element} from "chart.js";
import TopTemplate from "../components/toptemplate/TopTemplate.vue";
import CoursesService from "../services/courses.service";
import useValidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import {mapGetters} from "vuex";

export default {
  name: "MatiereList",
  components: {
    TopTemplate,
  },
  data() {
    return {
      v$: useValidate(),
      errorMessage: false,
      showInvalidFormatError: false,
      loading: false,
      courses: [],
      is_checked: [],
      selected: [],
      selectedValue: [],
      params: {
        school_id: null,
      },
      is_created: false,
      showModal: false,
      nameMatiere: "",
      passageYears: null,
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusSchoolYear(){
      return this.getPassageYears.status;
    }
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.passageYears = val.id;
        this.CourseList();
      }
    },
  },
  validations() {
    return {
      nameMatiere: {
        required: helpers.withMessage(this.$t("validation.required"), required),
      },
    };
  },

  created() {
    this.params.school_id = this.$store.state.auth.user.school_id;

    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.CourseList();
    }
  },
  methods: {
    addMatiere() {
      this.errorMessage = false;
      this.v$.$validate();
      if (!this.v$.$error) {
        const data = {
          name: this.nameMatiere,
        };
        CoursesService.add(data)
          .then((response) => {
            this.showModal = false;
            this.CourseList();
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.errorMessage = error.response.data.message;
            }
            this.showModal = false;
            this.nameMatiere = "";
            this.v$.$reset();
          })
          .finally(() => {
            this.loading = false;
            this.nameMatiere = "";
            this.v$.$reset();
          });
      }
    },
    hideModal() {
      this.showModal = false;
      this.nameMatiere = "";
      this.v$.$reset();
    },
    checkItem(id) {
      if (this.selected.includes(id)) {
        this.selected = this.selected.filter((el) => el != id);
      } else {
        this.selected.push(id);
      }
    },
    CourseList() {
      this.loading = true;
      const config = {
        params: {
          school_year: this.passageYears,
        },
      };
      CoursesService.getAll(config).then(
        (response) => {
          this.courses = _.orderBy(response.data.data, "name");
          this.courses.forEach((element) => {
            // return (item.select = false);
            if (element.is_checked == true) {
              this.selected.push(element.id);
            }
            if (element.is_checked == true) {
              this.selectedValue.push({
                course_id: element.id,
                is_checked: 1,
              });
            } else {
              this.selectedValue.push({
                course_id: element.id,
                is_checked: 0,
              });
            }
          });
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    onSubmitCreateCourse() {
      this.loading = true;
      this.selectedValue.forEach((item) => {
        if (this.selected.includes(item.course_id)) {
          item.is_checked = 1;
        } else {
          item.is_checked = 0;
        }
      });
      const data = {
        course_ids: this.selectedValue,
      };

      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });

      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmSendCourse"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            // swalWithBootstrapButtons.fire(
            //     this.$t("common.messageSend"),
            //     "",
            //     "success"
            // );

            CoursesService.create(data, this.params.school_id)
              .then((response) => {
                this.is_created = true;
                this.loading = false;
                this.scrollToTop();
              })
              .then(() => {
                this.$nextTick(() => {
                  // this.devoir.reset();
                });
              })
              .catch((error) => {
                this.is_created = false;
                this.loading = false;
                this.scrollToTop();
              });
          }
        });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.title-modal {
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: left;
  color: #34b9bb;
}

.cancel {
  margin-right: 15px;

  i {
    transform: rotate(45deg);
  }
}
.icon-edit-02 {
  border-radius: 50%;
  pointer-events: none;
  background: white;
  padding: 7px;
  margin-right: 20px;
  font-size: 13px;
}
</style>